import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import Icon from './Icon';

const ChildNavItem = ({ icon, label, widen = false, ...props }) => (
  <Link
    {...props}
    className={classnames(
      'flex items-center py-1 lg:py-2 block text-mid-gray lg:text-haiti lg:border-l-4 lg:border-transparent lg:hover:border-rose lg:hover:bg-whisper text-sm',
      { 'lg:px-4 px-2': !widen, 'lg:pl-4 lg:pr-12 px-2': widen }
    )}
  >
    <Icon icon={icon} size="small" className="mr-3" />
    {label}
  </Link>
);

export default ChildNavItem;
